import { Tab as SemanticTab } from 'semantic-ui-react';

export { TabProps, StrictTabProps } from 'semantic-ui-react';

export const Tab: typeof SemanticTab = SemanticTab;

export default Tab;
